// extracted by mini-css-extract-plugin
module.exports = {"battle-page":"Battle_battle-page__GoH1x"};